import styled from 'styled-components';

export const StrictWidthContainer = styled.div<{ $width?: string }>`
    max-width: ${({ $width }) => $width || '100%'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
